/** Shared guest application draft helpers (localStorage). */

export const GUEST_DRAFT_KEY = 'application_guest_draft';

export function loadGuestDraft() {
  try {
    const raw = localStorage.getItem(GUEST_DRAFT_KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    return parsed && typeof parsed === 'object' ? parsed : null;
  } catch {
    return null;
  }
}

export function saveGuestDraft(payload) {
  const existing = loadGuestDraft() || {};
  const nextDraft = {
    ...existing,
    ...payload,
    updated_at: new Date().toISOString(),
  };
  localStorage.setItem(GUEST_DRAFT_KEY, JSON.stringify(nextDraft));
}

export function clearGuestDraft() {
  localStorage.removeItem(GUEST_DRAFT_KEY);
}

export function loadGuestDraftPhone() {
  const draft = loadGuestDraft();
  return typeof draft?.phone === 'string' ? draft.phone : '';
}
